import mouse from "/assets/images/advantages/webp/mouse.webp";
import loupe from "/assets/images/advantages/webp/loupe.webp";
import watch from "/assets/images/advantages/webp/watch.webp";
import mouseMobile from "/assets/images/advantages/webp/Frame61.png";
import loupeMobile from "/assets/images/advantages/webp/loupeMobile.webp";
import watchMobile from "/assets/images/advantages/webp/watchMobile.webp";
import type { IProductivity } from "../config";

export const productivityMock: IProductivity = {
  productivityItems: [
    {
      utilClasses: "col-span-7 mobile:col-span-12",
      title: <>Save 8+ hours weekly on complex videos</>,
      desc: <>lectures, tutorials, and interviews</>,
      img: {
        alt: "watch",
        desktop: watch,
        mobile: watchMobile,
      },
    },
    {
      utilClasses: "col-span-5 mobile:col-span-12",
      title: <><span style={{ color: "white" }}>Cut</span> <br /> <span style={{ color: "white" }}>research time</span></>,
      desc: <><span style={{ color: "white" }}>10x faster answers</span><br />through summary & chat</>,
      img: {
        alt: "loupe",
        desktop: loupe,
        mobile: loupeMobile,
      },
    },
    {
      utilClasses: "col-span-5 mobile:col-span-12",
      title: <><span style={{ color: "white" }}>Skip</span> <br /> <span style={{ color: "white" }}>clickbait</span></>,
      desc: <>Cut your decision time<br /><span style={{ color: "white" }}>from minutes to seconds</span></>,
      img: {
        alt: "mouse",
        desktop: mouse,
        mobile: mouseMobile,
      },
    },
  ],
};
